import React from "react";
import cn from "classnames";

const Input = (props) => {
  const {
    type,
    label,
    hideLabel,
    value,
    name,
    onChange,
    disabled,
    required,
    placeholder,
    onClick,
    smallPaddingLeft,
    paddingLeft,
    bigPaddingLeft,
    lightFont,
    noBorder,
    textRight,
  } = props;

  return (
    <div>
      <label
        htmlFor={name}
        className={cn({ "sr-only": hideLabel, "text-black": lightFont })}
      >
        {label}
      </label>
      <input
        id={name}
        type={type}
        value={value ?? ""}
        name={name}
        onChange={onChange}
        onClick={onClick}
        disabled={disabled}
        required={required}
        placeholder={placeholder}
        className={cn(
          "w-full min-w-min h-9 px-1 border border-gray-300 rounded-md",
          {
            "pl-4": smallPaddingLeft,
            "pl-5": paddingLeft,
            "pl-8": bigPaddingLeft,
            "mt-1": lightFont,
            "border border-white": noBorder,
            "text-right": textRight,
          }
        )}
      />
    </div>
  );
};

export default Input;
